import { Link } from 'react-router-dom';

const plans = [
  {
    name: 'システム開発',
    icon: 'ri-server-line',
    price: '要お見積もり',
    description: '業務システム・基幹システムの開発',
    features: ['要件定義・設計込み', 'クラウド対応', '保守・運用サポート'],
    color: 'border-teal-400',
    badge: '',
  },
  {
    name: 'アプリ開発',
    icon: 'ri-smartphone-line',
    price: '要お見積もり',
    description: 'iOS / Android アプリ開発',
    features: ['UI/UXデザイン込み', 'ストア申請サポート', 'アップデート対応'],
    color: 'border-cyan-400',
    badge: '人気',
  },
  {
    name: 'Webサービス',
    icon: 'ri-global-line',
    price: '月額 ¥50,000〜',
    description: 'Webサービス開発・運営・広告',
    features: ['サービス企画・開発', 'インターネット広告', 'SEO・グロース支援'],
    color: 'border-emerald-400',
    badge: '',
  },
];

export default function PlansOverview() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-teal-500 text-xs font-semibold uppercase tracking-widest mb-2">Pricing</p>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            料金プラン
          </h2>
          <p className="text-gray-500 text-sm max-w-xl mx-auto">
            サービス種別ごとに最適なプランをご用意しています。<br className="hidden md:block" />
            まずはお気軽にご相談ください。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`relative rounded-2xl border-2 ${plan.color} bg-white p-6 flex flex-col`}
            >
              {plan.badge && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-teal-400 to-cyan-500 text-white text-xs font-bold px-3 py-0.5 rounded-full whitespace-nowrap">
                  {plan.badge}
                </span>
              )}
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-teal-50 mb-4">
                <i className={`${plan.icon} text-teal-600 text-lg`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {plan.name}
              </h3>
              <p className="text-gray-500 text-xs mb-3">{plan.description}</p>
              <div className="text-xl font-bold text-teal-600 mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {plan.price}
              </div>
              <ul className="space-y-2 mb-6 flex-1">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-xs text-gray-600">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-check-line text-teal-500 text-xs"></i>
                    </div>
                    {f}
                  </li>
                ))}
              </ul>
              <Link
                to="/contact"
                className="block text-center py-2.5 rounded-full border border-teal-400 text-teal-600 text-sm font-semibold cursor-pointer hover:bg-teal-50 transition-colors whitespace-nowrap"
              >
                相談する
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/plans"
            className="inline-flex items-center gap-2 text-teal-600 text-sm font-medium cursor-pointer hover:gap-3 transition-all"
          >
            詳細な料金プランを見る
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
